import React from 'react'

const data=[
  {
    id:'1',
    imgurl:"./a.jpg",
  },
  {
    id:'2',
    imgurl:"./2.png",
  },
  {
    id:'3',
    imgurl:"./3.png",
  },
  {
    id:'4',
    imgurl:"./5.png",
  },
  {
    id:'5',
    imgurl:"./1.png",
  },
]

export default function Gallerygrid() {
  return (
    <section className="overflow-hidden text-gray-700">
  <div className="container px-4 mx-auto lg:px-40">
    <div className="flex flex-wrap md:-m-2">
      <div className="flex flex-wrap w-1/2">
      {data.slice(0,2).map((item)=>(
        <div key={item.id} className="w-full p-1 md:p-2">
          <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
            src={item.imgurl}/>
        </div>
      ))}
      {data.slice(2,3).map((item)=>(
        <div key={item.id} className="w-full p-1 md:p-2">
          <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
            src={item.imgurl}/>
        </div>
      ))}
      </div>
      <div className="flex flex-wrap w-1/2">
      {data.slice(3,4).map((item)=>(
        <div key={item.id} className="w-full p-1 md:p-2">
          <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
            src={item.imgurl}/>
        </div>
      ))}
      {data.slice(4,5).map((item)=>(
        <div key={item.id}  className="w-full p-1 md:p-2">
          <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
            src={item.imgurl}/>
        </div>
      ))}
      </div>
    </div>
  </div>
</section>
  )
}